import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { UserStore } from '../services/user-store.service';

export const adminGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isAdmin()) {
    return true;
  }

  if (userStore.isLider()) {
    return router.createUrlTree(['/lider']);
  }

  return router.createUrlTree(['/perfil']);
};
